import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "../styles/brands.css";
import { Checkbox, Radio } from "antd";
import axios from "axios";
import { Price } from "../pages/Price";
import { ColorRing } from "react-loader-spinner";
import { server } from "../server";
import CarCard from "./CarCard";

const CarsHome = () => {
  const [cars, setcars] = useState([]);
  const [brand, setBrand] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedPriceRange, setSelectedPriceRange] = useState(null);
  const [search, setsearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [showFilters, setShowFilters] = useState(false);

  const pageTitle = "Premium Cars for Sale in Kenya | Classic Motors KE";
  const pageDescription =
    "Discover the best deals on new, foreign, and locally used cars in Mombasa. Classic Motors KE offers reliable vehicles with 100% delivery record. Call 0707308556 today!";
  const canonicalUrl = "https://www.classicmotorske.com/cars";

  const getAllBrand = async () => {
    try {
      const { data } = await axios.get(`${server}/api/brand/getAll-brand`);
      if (data.success) setBrand(data.brands);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(true);
    }
  };

  const getAllcars = async () => {
    try {
      const data = await fetch(`${server}/api/car/getAll-car`);
      const data_ = await data.json();
      setcars(data_?.cars?.reverse());
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(true);
    }
  };

  const handleBrandChange = (e, brandId) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedBrands((prev) => [...prev, brandId]);
    } else {
      setSelectedBrands((prev) => prev.filter((id) => id !== brandId));
    }
  };

  const handlePriceChange = (e) => {
    setSelectedPriceRange(e.target.value);
  };

  const resetFilters = () => {
    setSelectedBrands([]);
    setSelectedPriceRange(null);
    setsearch("");
  };

  useEffect(() => {
    getAllBrand();
    getAllcars();
    window.scrollTo(0, 0);
  }, []);

  const generateCarSchema = () => {
    const carOffers = cars.map((car) => ({
      "@type": "Offer",
      url: `${canonicalUrl}/${car.slug || car._id}`,
      priceCurrency: "KES",
      price: car.price,
      itemCondition: "https://schema.org/UsedCondition",
      availability: "https://schema.org/InStock",
      seller: {
        "@type": "Organization",
        name: "Classic Motors KE",
      },
    }));

    return {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: pageTitle,
      description: pageDescription,
      url: canonicalUrl,
      mainEntity: {
        "@type": "AutoDealer",
        name: "Classic Motors KE",
        image: "https://www.classicmotorske.com/logo.png",
        telephone: "+254707308556",
        address: {
          "@type": "PostalAddress",
          addressLocality: "Mombasa",
          addressCountry: "KE",
        },
        makesOffer: carOffers,
      },
    };
  };

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta
          name="keywords"
          content="cars for sale Kenya, used cars Mombasa, new cars Kenya, car import Kenya, Classic Motors KE, vehicle dealer Mombasa"
        />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <script type="application/ld+json">
          {JSON.stringify(generateCarSchema())}
        </script>
      </Helmet>

      <div
        className="brand_wrapper"
        id="cars"
        style={{ marginTop: "60px", padding: "5px" }}
      >
        <div className="col-12 text-center">
          <h1 className="brand_title">
            Premium Cars for Sale in Mombasa, Kenya
          </h1>
          <p className="brand_subtitle">
            Trusted Dealer of New, Foreign & Locally Used Vehicles | 100%
            Delivery Record
          </p>
        </div>
      </div>

      <div className="container">
        <div className="d-lg-none d-flex justify-content-end my-3">
          <button
            className="btn btn-outline-primary"
            onClick={() => setShowFilters(!showFilters)}
          >
            {showFilters ? "Close Filters" : "Show Filters"}
          </button>
        </div>

        <div
          className="row"
          style={{ marginBottom: "100px", marginTop: "30px" }}
        >
          {(showFilters || window.innerWidth >= 992) && (
            <div className="col-lg-3 col-12 mb-4 mb-lg-0">
              <div className="p-3 border rounded bg-light">
                <h2 className="h5">🔎 Search Your Car</h2>
                <input
                  type="search"
                  placeholder="Search by make, model or type..."
                  onChange={(e) => setsearch(e.target.value.toLowerCase())}
                  className="form-control mb-3"
                />
                <h5>Filter By Brands</h5>
                <div className="d-flex flex-column mb-3">
                  {brand?.map((c) => (
                    <Checkbox
                      key={c._id}
                      onChange={(e) => handleBrandChange(e, c._id)}
                      checked={selectedBrands.includes(c._id)}
                    >
                      {c.name}
                    </Checkbox>
                  ))}
                </div>
                <h5>Filter By Price Range (KES)</h5>
                <Radio.Group
                  onChange={handlePriceChange}
                  value={selectedPriceRange}
                >
                  {Price.map((p) => (
                    <Radio key={p._id} value={p.array}>
                      {p.name}
                    </Radio>
                  ))}
                </Radio.Group>
                <button
                  className="btn btn-outline-dark mt-3 w-100"
                  onClick={resetFilters}
                >
                  RESET FILTERS
                </button>
              </div>
            </div>
          )}

          <div className="col-lg-9 col-12">
            {loading ? (
              <div className="h-100 d-flex align-items-center justify-content-center">
                <ColorRing
                  visible={true}
                  colors={[
                    "#000435",
                    "rgb(14 165 233)",
                    "rgb(243 244 246)",
                    "#000435",
                    "rgb(14 165 233)",
                  ]}
                />
              </div>
            ) : (
              <div className="row">
                {cars
                  .filter((car) => {
                    return search.toString().toLowerCase() === ""
                      ? car
                      : car.name.toLowerCase().includes(search);
                  })
                  .filter(
                    (car) =>
                      selectedBrands.length === 0 ||
                      selectedBrands.includes(car.brand._id)
                  )
                  .filter((car) => {
                    if (!selectedPriceRange) return true;
                    const [minPrice, maxPrice] = selectedPriceRange;
                    return car.price >= minPrice && car.price <= maxPrice;
                  })
                  .map((p) => (
                    <div key={p._id} className="col-md-6 col-lg-4 mb-3">
                      <CarCard p={p} />
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CarsHome;
